import { useRef, useEffect } from 'react';


function useEventHandler({ element, eventName, handleEvent }) {
    const handlerRef = useRef();

    useEffect(() => {
        handlerRef.current = handleEvent;
    }, [handleEvent]);

    useEffect(() => {
        if (!element) {
            return;
        }
        const listener = e => handlerRef.current(e);
        element.addEventListener(eventName, listener);

        return () => {
            element.removeEventListener(eventName, listener);

        };
    }, [element, eventName]);
}

export {
    useEventHandler
}